// src/pages/TextesReglementaires/utils/legalPagesUtils.js

export function getSettingsRecord(data) {
  if (Array.isArray(data)) return data[0] || {};
  return data || {};
}

export function getMairieIdentity(settings = {}) {
  const siteUrl =
    settings.siteweb_mairie ||
    settings.siteweb_commune ||
    settings.siteweb_club ||
    window.location.origin;

  const name =
    settings.nom_mairie ||
    settings.nom_commune ||
    settings.nom_club ||
    "la commune";

  const address =
    settings.adresse_mairie ||
    settings.adresse_commune ||
    settings.adresse_club ||
    "";

  const publicationDirector =
    settings.directeur_publication ||
    settings.responsable_publication ||
    settings.maire ||
    settings.responsable_club ||
    "le Maire";

  const email =
    settings.mail_mairie ||
    settings.email_mairie ||
    settings.mail_commune ||
    settings.mail_club ||
    "";

  const phone =
    settings.tel_mairie ||
    settings.telephone_mairie ||
    settings.tel_club ||
    "";

  const siret =
    settings.siret_mairie ||
    settings.siret_commune ||
    settings.siret_club ||
    settings.siret ||
    "";

  const dpoEmail =
    settings.mail_dpo ||
    settings.dpo_email ||
    settings.email_dpo ||
    email;

  const hostName =
    settings.hebergeur_nom ||
    settings.host_name ||
    "Hébergeur à renseigner";

  const hostAddress =
    settings.hebergeur_adresse ||
    settings.host_address ||
    "Adresse de l’hébergeur à renseigner";

  return {
    siteUrl,
    name,
    address,
    publicationDirector,
    email,
    phone,
    siret,
    dpoEmail,
    hostName,
    hostAddress,
  };
}

export function formatLegalDate(value) {
  if (!value) {
    return new Date().toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}